import { logWarningToDatadog } from '@/common/utils'
import { getSubject } from '@/service/api'
import { UserObj } from '@/store/modules/webchat'

export const initFullView = async (token: string, user: UserObj) => {
  try {
    const subject = await getSubject(token)

    if (subject !== undefined) {
      (window as any).$fvIdentity = {
        id: subject.id,
        name: subject.name,
        email: subject.email,
        env: process.env.NODE_ENV === 'production' ? 'prod' : 'dev',
        app: 'bot',
        roles: ['bot'],
      }
    }
  } catch (e) {
    const error = e as Error
    logWarningToDatadog('Unable to initialize FullView', {
      user,
      errorMessage: error.message,
    })
  }
}
